import * as React from 'react'
import { App } from "./App";
import { Main } from "@commons/Componentes/MainPanel";
import { getComponentWithLoading } from "@commons/Utils";
import { MiCuenta } from "@commons/Views/MiCuenta/MiCuenta";
import { Asistente } from "@seguridad/Components/Asistente/Asistente";
import { ConocimientoIAEdit } from "@seguridad/Components/ConocimientoIA/ConocimientoIAEdit";
import { ConfiguracionInicialView } from "@configuracionInicial/Views/ConfiguracionInicialView";
const getComponent = (component) => {
    return getComponentWithLoading(component)();
  };
  
export const routes = [
    {
        path: "/",
        element: <App/>,
        children: [
            {
                path: "/App/ConfiguracionInicial",
                element: <ConfiguracionInicialView />,
            },
            {
                path: "/App/Seguridad/MiCuenta",
                element: <MiCuenta />,
            },
            {
                path: "/App/Seguridad/Asistente",
                element: <Asistente />,
            },
            {
                path: "/App/Seguridad/CitrusGPT",
                element: <Asistente />,
            },
            {
                path: "/App/Seguridad/ConocimientoIAEdit",
                element: <ConocimientoIAEdit />,
            },
            {
                path: "/",
                element: <Main />,
                index: true
            },
            {
                path: "*",
                element:  <Main />,
            }
        ],
    },
];

